import styled from "styled-components";

const TextButton = styled.button`
  color: var(--terbine-blue);
  text-decoration: underline;

  &:hover {
    color: lab(from var(--terbine-blue) calc(l - 20) a b / 100);
    cursor: pointer;
  }
`;

export default TextButton;
